import cianMetrics from '@cian/metrics';

// eslint-disable-next-line import/no-default-export
export default function () {
  const setMetric = name => {
    cianMetrics.add(name);
  };

  return {
    setMetric,
    $get: [
      '$log',
      $log => {
        return {
          setMetric,
          sendMetric: (prefix, name, value, type = 'timer') => {
            if (process.env.NODE_ENV !== 'development') {
              cianMetrics.send([
                {
                  name: `${prefix}.${name}`,
                  type,
                  value,
                },
              ]);
            } else {
              $log.debug('Send metric', prefix, name, value);
            }
          },
          sendStats: prefix => {
            if (process.env.NODE_ENV !== 'development') {
              cianMetrics.waitForAllBrowserMetrics(() => {
                const metrics = cianMetrics.collect(prefix);
                cianMetrics.send(metrics);
              });
            } else {
              $log.debug('Send metrics', cianMetrics.collect(prefix));
            }
          },
        };
      },
    ],
  };
}
